import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, doc, getDoc, deleteDoc } from 'firebase/firestore';

function ClienteDetalle() {
  const { id } = useParams();
  const [cliente, setCliente] = useState(null);
  const [ventas, setVentas] = useState([]);
  const [servicios, setServicios] = useState([]);

  useEffect(() => {
    const obtenerDatos = async () => {
      const clienteDoc = await getDoc(doc(db, 'clientes', id));
      if (clienteDoc.exists()) {
        setCliente(clienteDoc.data());
      }

      const ventasQuery = query(collection(db, 'ventas'), where('clienteId', '==', id));
      const ventasSnap = await getDocs(ventasQuery);
      const ventasData = ventasSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setVentas(ventasData);

      const serviciosQuery = query(collection(db, 'servicios'), where('clienteId', '==', id));
      const serviciosSnap = await getDocs(serviciosQuery);
      const serviciosData = serviciosSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setServicios(serviciosData);
    };

    obtenerDatos();
  }, [id]);

  const eliminarServicio = async (servicioId) => {
    await deleteDoc(doc(db, 'servicios', servicioId));
    setServicios(servicios.filter(s => s.id !== servicioId));
  };

  const formatearFecha = (fecha) => {
    if (fecha && typeof fecha.toDate === 'function') {
      return fecha.toDate().toLocaleDateString();
    }
    return 'Fecha no disponible';
  };

  if (!cliente) return <p style={{ padding: '20px', color: 'white' }}>Cargando datos del cliente...</p>;

  return (
    <div className="cliente-detalle" style={{ padding: '20px', color: 'white' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>Historial de {cliente.nombre}</h2>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ color: '#ff4500' }}>Ventas</h3>
        {ventas.length === 0 ? (
          <p>No hay ventas registradas.</p>
        ) : (
          <ul>
            {ventas.map((venta) => (
              <li key={venta.id} style={{ marginBottom: '16px', backgroundColor: '#1f1f1f', padding: '12px', borderRadius: '6px' }}>
                <strong>Fecha:</strong> {formatearFecha(venta.fecha)}<br />
                <strong>Total:</strong> ${venta.total.toFixed(2)}<br />
                <strong>Productos:</strong>
                <ul>
                  {venta.productos.map((p, idx) => (
                    <li key={idx}>{p.nombre} x{p.cantidad} - ${p.precio}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div>
        <h3 style={{ color: '#ff4500' }}>Servicios</h3>
        {servicios.length === 0 ? (
          <p>No hay servicios registrados.</p>
        ) : (
          <ul>
            {servicios.map((servicio) => (
              <li key={servicio.id} style={{ marginBottom: '16px', backgroundColor: '#1f1f1f', padding: '12px', borderRadius: '6px' }}>
                <strong>Fecha:</strong> {formatearFecha(servicio.fecha)}<br />
                <strong>Descripción:</strong> {servicio.descripcion || 'Sin descripción'}<br />
                <strong>Precio:</strong> ${servicio.precio?.toFixed(2) || '0.00'}<br />
                <strong>Vehículo:</strong> {servicio.vehiculo || 'No especificado'}<br />
                <button
                  onClick={() => eliminarServicio(servicio.id)}
                  style={{ marginTop: '8px', backgroundColor: '#cc0000', color: 'white', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'pointer' }}
                >
                  Eliminar servicio
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Link to="/clientes" style={{ display: 'inline-block', marginTop: '30px', color: '#4aa3ff' }}>
        ← Volver a Clientes
      </Link>
    </div>
  );
}

export default ClienteDetalle;
